module.exports = __webpack_public_path__ + "88fa6e1302211c76653d7f5df3de5672.png";